import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Numeric metric card. Establishes the standard data display for the entire
 * application. Keep values tabular and labels small/muted.
 */
export const MetricCard = ({
  label,
  value,
  delta,
  trend = "neutral", // "up" | "down" | "neutral"
  hint,
  className,
  testId,
}) => {
  const TrendIcon = trend === "up" ? ArrowUpRight : trend === "down" ? ArrowDownRight : Minus;
  const trendClass =
    trend === "up"
      ? "text-emerald-600 dark:text-emerald-400"
      : trend === "down"
      ? "text-rose-600 dark:text-rose-400"
      : "text-muted-foreground";

  return (
    <div
      data-testid={testId || "metric-card"}
      className={cn(
        "flex flex-col gap-2 rounded-xl border border-border bg-card p-6 transition-colors hover:bg-surface/40",
        className
      )}
    >
      <div className="text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
        {label}
      </div>
      <div className="flex items-baseline gap-2">
        <span className="text-3xl font-medium tabular-nums tracking-tight text-foreground sm:text-4xl">
          {value}
        </span>
        {delta && (
          <span className={cn("inline-flex items-center gap-0.5 text-xs font-medium tabular-nums", trendClass)}>
            <TrendIcon className="h-3 w-3" />
            {delta}
          </span>
        )}
      </div>
      {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
};

export default MetricCard;
